export default {
  roadmapMetadata: {
    changeMentorTitle: 'Назначить наставника',
    createMaterialTitle: 'Новый материал',
    changeMaterialTitle: 'Редактировать материал',
    formLabels: {
      name: 'Название материала',
      skillId: 'Компетенция',
      deadline: 'Дедлайн',
      typeId: 'Тип материала',
      importance: 'Важность',
    },
    statuses: {
      all: 'Все',
      new: 'Новая',
      inProgress: 'В работе',
      done: 'Готово',
    },
    addMaterialFieldsButton: 'Добавить материал',
    removeMaterialFieldsButton: 'Удалить материал',
    moveMaterialsButton: {
      top: 'Переместить в прочие навыки для развития',
      general: 'Переместить в очевидные зоны роста',
    },
    headers: {
      name: 'Материал',
      type: 'Тип материала',
      importance: 'Важность',
      deadline: 'Дедлайн',
      status: 'Статус',
    },
    tooltips: {
      manualMaterial: 'Материал добавлен в плане развития',
      manualTask: 'Задача добавлена в плане развития',
      showMaterial: 'Материал добавлен на доску',
      showTask: 'Задача добавлена на доску',
      supervisorButton: 'Зачем обновлять и фиксировать план развития',
      employeeButton: 'Зачем обновлять план развития',
      employee:
        'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план вручную.',
      supervisor:
        'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план вручную. После фиксации плана, кнопка «Обновить план» станет недоступной, но вы сможете добавлять, удалять и перемещать задачи между блоками.',
      button: 'Зачем обновлять и фиксировать план развития',
      text: 'Обновите план развития, чтобы получить наиболее актуальные результаты на основе последних оценок. Обратите внимание, что текущий прогресс будет сброшен, не будут удалены только задачи которые были добавлены в план в ручную. После фиксации плана, кнопка «Обновить план» станет недоступной. Внесение изменений в план также станет невозможным.',
    },
    selectDateButton: 'Выбрать дату',
    selectImportanceButton: 'Выбрать важность',
    devPlanTitle: 'План развития компетенций',
    recreateRoadmapButton: 'Обновить план',
    fixateRoadmapButton: 'Зафиксировать изменения',
    requiredTarget: 'Поля «Описание цели» и «Дедлайн» - обязательные',
    commonMaterialsTitle: 'Общие материалы и задачи для развития',
    blocksMaterialsTitle: 'Материалы и задачи по результатам оценки',
    topSectionTitle: 'Очевидные зоны роста',
    generalSectionTitle: 'Прочие материалы и задачи для развития',
    progressDescription: 'Общий прогресс выполнения плана развития',
    lowSkills: 'Компетенции, по которым у пользователя самые низкие оценки',
    // messages
    successMessages: {
      changeMentor: 'Наставник успешно изменён',
      saveTarget: 'Цель успешно сохранена',
      createMaterial: 'Материал успешно создан',
      changeMaterial: 'Материал успешно изменён',
      showMaterials: 'Материалы успешно добавлены на доску',
      moveMaterials: 'Материалы успешно перемещены',
      deleteMaterials: 'Материалы успешно удалены',
      changeTask: 'Задача успешно изменёна',
      recreateRoadmap: 'План развития успешно обновлён',
      fixateRoadmap: 'План развития успешно зафиксирован',
    },
    errorMessages: {
      changeMentor: 'Не удалось изменить наставника',
      saveTarget: 'Не удалось сохранить цель',
      createMaterial: 'Не удалось создать материал',
      changeMaterial: 'Не удалось изменить материал',
      showMaterials: 'Не удалось добавить материалы на доску',
      moveMaterials: 'Не удалось переместить материалы',
      deleteMaterials: 'Не удалось удалить материалы',
      changeTask: 'Не удалось изменить задачу',
      recreateRoadmap: 'Не удалось обновить план развития',
      fixateRoadmap: 'Не удалось зафиксировать план развития',
      targetRoadmap: 'Необходимо заполнить «Цель», чтобы зафиксировать план развития',
    },
    // confirm dialogs
    confirmShowMaterials: {
      title: 'Добавить материалы на доску?',
      button: 'Да, добавить',
    },
    confirmMoveMaterials: {
      title: 'Переместить материалы?',
      button: 'Да, переместить',
    },
    confirmDeleteMaterials: {
      title: 'Удалить материалы?',
      text: 'Отменить данное действие будет невозможно',
    },
    confirmRecreateRoadmap: {
      title: 'Обновить план?',
      text: 'План будет сформирован заново и изменения будут утеряны.',
      button: 'Да, обновить',
    },
    confirmFixateRoadmap: {
      title: 'Зафиксировать план?',
      text: 'Внесение изменений в состав плана станет недоступно.',
      button: 'Да, зафиксировать',
    },
    //
  },
};
